<div
    class="min-h-screen
           bg-[#f7f6f4]
           text-[#1c1917]"
>

    <!-- ====================================================== -->
    <!-- SIDEBAR DESKTOP -->
    <!-- ====================================================== -->

    <div
        class="fixed left-0 top-0 z-40
               hidden h-screen w-[250px]
               lg:block"
    >
        <app-sidebar></app-sidebar>
    </div>


    <!-- ====================================================== -->
    <!-- SIDEBAR MOBILE -->
    <!-- ====================================================== -->

    @if (sidebarOpen) {

        <div
            class="fixed inset-0 z-40
                   bg-black/45
                   backdrop-blur-[2px]
                   lg:hidden"
            (click)="closeSidebar()"
        ></div>


        <div
            class="fixed left-0 top-0 z-50
                   h-screen w-[280px]
                   shadow-2xl
                   lg:hidden"
        >
            <app-sidebar></app-sidebar>
        </div>

    }


    <!-- ====================================================== -->
    <!-- CONTENT -->
    <!-- ====================================================== -->

    <div
        class="min-h-screen
               lg:pl-[250px]"
    >

        <app-topbar
            (menuClick)="toggleSidebar()"
        ></app-topbar>


        <main
            class="px-4 py-6
                   sm:px-6
                   lg:px-8
                   xl:py-7"
        >

            <div
                class="mx-auto
                       w-full
                       max-w-[1600px]"
            >

                <router-outlet></router-outlet>

            </div>

        </main>

    </div>

</div>